/**
 * Save to Cosmos — save images / videos / links to a Cosmos collection
 *
 * Declares one web-accessible-resource entry — assets/* — matched to every origin with
 * no use_dynamic_url, so its whole bundled asset tree (images, fonts, Lottie files) is
 * fetchable from any page at a stable URL.
 *
 * The toolbar icon loads through probeImage with no CORS grant. The vendor-named
 * CosmosOracle web fonts corroborate it and are unmistakably this extension's.
 *
 * Manifest verified against version 6.14.4.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'mgjneceglphcpbbfbhjplkpgfapebmdg';

export const saveToCosmos: ExtensionDefinition = {
  id: ID,
  name: 'Save to Cosmos',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'assets/* exposed to every origin with no dynamic URL. The icon is CORS-free and ' +
    'the vendor-named CosmosOracle fonts are conclusive.',
  signals: [
    {
      id: 'war-icon-128',
      kind: 'web-accessible-resource',
      description:
        'Load assets/img/icon-128.png via <img> — exposed to every origin, readable ' +
        'without a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'assets/img/icon-128.png'),
    },
    {
      id: 'war-cosmosoracle-font',
      kind: 'web-accessible-resource',
      description:
        'Fetch assets/fonts/CosmosOracle-Bold.woff2 — a vendor-named web font, distinctive to Cosmos.',
      weight: 0.5,
      run: () => probeFetch(ID, 'assets/fonts/CosmosOracle-Bold.woff2'),
    },
    {
      id: 'war-idle-lottie',
      kind: 'web-accessible-resource',
      description: 'Fetch assets/lottie/idle.lottie — a bundled Lottie animation, a third path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'assets/lottie/idle.lottie'),
    },
  ],
};
